import {Grid } from '@mui/material'
import React from 'react'
import { FooterGrid,FooterDec,FooterContainer,ImgGrid,Socialimg,WantedImg,CopyRights,CopyRightGrid,VideoBK,SocialDiv
,DivContainer,FooterLogo,FooterLogoDiv } from './style'

const footer = () => {
  return (
        <FooterContainer maxWidth="xxl">
        <VideoBK autoPlay loop playsInline muted>
            <source src="./assets/footer-video.mp4" type="video/mp4" />
          </VideoBK>
          <DivContainer>
            <FooterGrid container>
                <Grid item xs={12} sm={8} data-aos="fade-right" data-aos-duration="1000">
                    <FooterDec>$GEAR5 is a meme coin with no intrinsic value or expectation of financial return. The coin is completely for entertainment purposes only.
                    </FooterDec>
                    <SocialDiv style={{display:"flex"}}>
                        <a href="https://twitter.com/luffycoineth" target='blank' style={{display:"flex",justifyContent:"center",width: "fit-content"}}><Socialimg src="./assets/twitter.png" alt="" /></a>
                        <a href="https://t.me/luffycoineth" target='blank' style={{display:"flex",justifyContent:"center",width: "fit-content"}}><Socialimg src="./assets/tele.png" alt="" /></a>
                    </SocialDiv>
                </Grid>
                <ImgGrid item xs={12} sm={4} data-aos="fade-left" data-aos-duration="1000">
                    <div><WantedImg src="./assets/wanted.png" /></div>
                </ImgGrid>
            </FooterGrid>
            </DivContainer>
            <CopyRightGrid container>
                <Grid item xs={12} sm={6}>
                    <FooterLogoDiv><FooterLogo src="./assets/footer-logo.png" /></FooterLogoDiv>
                </Grid>
                <Grid item xs={12} sm={6} sx={{display:"flex",justifyContent:"end",alignItems:"center"}}>
                    <CopyRights></CopyRights>
                </Grid>
            </CopyRightGrid>
        </FooterContainer>
  )
}

export default footer
